import React from 'react';
import { useLocation } from 'react-router-dom';
import ProductPage from '../components/seo/ProductPage';
import { isEnglishPath } from '../utils/i18nRoutes';

const ALTERNATES = [
  { hreflang: 'es', href: '/robotica' },
  { hreflang: 'en', href: '/en/robotica' },
  { hreflang: 'x-default', href: '/robotica' },
];

const CONTENT = {
  es: {
    seoTitle: 'Robótica de campo | Robots en operaciones reales | Valoriza',
    seoDescription: 'Robots humanoides bípedos y cuadrúpedos integrados en operaciones reales de limpieza urbana. Unitree G1. En producción.',
    breadcrumbLabel: 'Robótica',
    tag: 'Robótica de campo',
    titleMain: 'Robótica que sale a la',
    titleAccent: 'calle',
    lead: 'Robots humanoides bípedos y cuadrúpedos integrados en operaciones reales de limpieza urbana. Unitree G1. En producción.',
    problema: 'La automatización de tareas de limpieza y mantenimiento urbano puede mejorar la eficiencia, la seguridad y la calidad del servicio. La integración de robots autónomos en entornos complejos como las calles de una ciudad presenta desafíos técnicos y operativos significativos.',
    comoFunciona: 'Estamos integrando robots humanoides (bípedos) y cuadrúpedos en operaciones reales de limpieza urbana. El modelo Unitree G1 es uno de los robots en producción que ya opera en campo, demostrando la viabilidad de la robótica avanzada para la gestión de servicios ambientales. Esta es la primera integración de este tipo en el sector ambiental español.',
    paraQuien: 'Administraciones públicas y empresas de servicios urbanos que buscan innovar en la automatización de la limpieza y el mantenimiento. Líderes de innovación interesados en la aplicación práctica de la robótica avanzada.',
    enlaces: [{ label: 'Exoesqueleto: la asistencia mecánica para operarios', to: '/exoesqueleto' }, { label: 'Cómo innovamos: nuestra estrategia', to: '/estrategia' }],
    ctaText: '¿Tienes un reto parecido?',
  },
  en: {
    seoTitle: 'Field robotics | Robots in real operations | Valoriza',
    seoDescription: 'Bipedal and quadrupedal humanoid robots integrated into real urban cleaning operations. Unitree G1. In production.',
    breadcrumbLabel: 'Robotics',
    tag: 'Field robotics',
    titleMain: 'Robotics that hits the',
    titleAccent: 'street',
    lead: 'Bipedal and quadrupedal humanoid robots integrated into real urban cleaning operations. Unitree G1. In production.',
    problema: 'Automating urban cleaning and maintenance tasks can improve efficiency, safety and service quality. Integrating autonomous robots into complex environments such as city streets presents significant technical and operational challenges.',
    comoFunciona: 'We are integrating humanoid (bipedal) and quadrupedal robots into real urban cleaning operations. The Unitree G1 is one of the robots already in production, operating in the field and demonstrating the viability of advanced robotics for environmental service management. This is the first integration of its kind in the Spanish environmental sector.',
    paraQuien: 'Public administrations and urban services companies looking to innovate in cleaning and maintenance automation. Innovation leaders interested in the practical application of advanced robotics.',
    enlaces: [{ label: 'Exoskeleton: mechanical assistance for operators', to: '/en/exoesqueleto' }, { label: 'How we innovate: our strategy', to: '/en/strategy' }],
    ctaText: 'Do you have a similar challenge?',
  },
};

export default function RoboticaPage() {
  const { pathname } = useLocation();
  const locale = isEnglishPath(pathname) ? 'en' : 'es';
  const c = CONTENT[locale];
  const path = locale === 'en' ? '/en/robotica' : '/robotica';

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: 'Robótica de campo',
    description: c.seoDescription,
    url: `https://innovation.valorizasm.com${path}`,
    brand: { '@id': 'https://innovation.valorizasm.com/#organization' },
  };

  return (
    <ProductPage
      testId="robotica-page"
      path={path}
      locale={locale}
      alternates={ALTERNATES}
      jsonLd={[jsonLd]}
      problemaLabel={locale === 'en' ? 'The problem' : 'El problema'}
      comoFuncionaLabel={locale === 'en' ? 'How it works' : 'Cómo funciona'}
      cifrasLabel={locale === 'en' ? 'Figures' : 'Cifras'}
      paraQuienLabel={locale === 'en' ? "Who it's for" : 'Para quién'}
      enlacesLabel={locale === 'en' ? 'Links' : 'Enlaces'}
      {...c}
    />
  );
}
